var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2077 13.5866L27.2459 22.727L24.5527 18.6279L38.5146 9.48754L41.2077 13.5866Z",
    fill: "#240630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.595 33.1941L38.5568 42.3344L41.25 38.2354L27.2882 29.095L24.595 33.1941Z",
    fill: "#240630"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7323 36.5245C20.2943 36.5245 24.8031 32.0237 24.8031 26.4717C24.8031 20.9197 20.2943 16.4189 14.7323 16.4189C9.17041 16.4189 4.66157 20.9197 4.66157 26.4717C4.66157 32.0237 9.17041 36.5245 14.7323 36.5245ZM14.7323 41.1777C22.8688 41.1777 29.4647 34.5936 29.4647 26.4717C29.4647 18.3497 22.8688 11.7656 14.7323 11.7656C6.5959 11.7656 0 18.3497 0 26.4717C0 34.5936 6.5959 41.1777 14.7323 41.1777Z",
    fill: "#240630"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.526 21.6453C10.8161 21.9403 10.8027 22.0609 10.8027 26.4981V30.6135L11.1242 30.9888C11.7269 31.6859 12.1019 31.5653 15.6912 29.5008C17.4591 28.4954 19.0662 27.4766 19.2805 27.2622C19.5082 27.0209 19.6421 26.7259 19.6421 26.4712C19.6421 26.2165 19.5082 25.9216 19.2805 25.6803C18.8252 25.1977 12.7045 21.6721 12.1822 21.5783C11.9813 21.5515 11.6733 21.5783 11.526 21.6453Z",
    fill: "#240630"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1617 13.3042C48.6407 13.3042 50.6503 11.2982 50.6503 8.82363C50.6503 6.34906 48.6407 4.34303 46.1617 4.34303C43.6827 4.34303 41.6731 6.34906 41.6731 8.82363C41.6731 11.2982 43.6827 13.3042 46.1617 13.3042ZM46.1617 17.6473C51.0435 17.6473 55.0011 13.6968 55.0011 8.82363C55.0011 3.95047 51.0435 0 46.1617 0C41.2798 0 37.3223 3.95047 37.3223 8.82363C37.3223 13.6968 41.2798 17.6473 46.1617 17.6473Z",
    fill: "#240630"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1617 45.6568C48.6407 45.6568 50.6503 43.6507 50.6503 41.1762C50.6503 38.7016 48.6407 36.6956 46.1617 36.6956C43.6827 36.6956 41.6731 38.7016 41.6731 41.1762C41.6731 43.6507 43.6827 45.6568 46.1617 45.6568ZM46.1617 49.9998C51.0435 49.9998 55.0011 46.0493 55.0011 41.1762C55.0011 36.303 51.0435 32.3525 46.1617 32.3525C41.2798 32.3525 37.3223 36.303 37.3223 41.1762C37.3223 46.0493 41.2798 49.9998 46.1617 49.9998Z",
    fill: "#240630"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDark);
export default __webpack_public_path__ + "static/media/shareDark.25185596fcc68595c79f53eebd2cd4b2.svg";
export { ForwardRef as ReactComponent };